module.exports = __webpack_public_path__ + "static/media/SchoolCosSchoolReceive4.d4e07cec.png";